export default __webpack_public_path__ + "static/media/wbPay1.ea1ae8d2.png";